import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';

// Own constants/actions/components
import { getExclusivityBannerAction } from 'services/actions/exclusivity-banner';
import { getSessionAction } from 'services/actions/header';
import { postShoppingCartAction } from 'services/actions/submit-shopping';
import { addPersonalDataToShoppingCartAction, resetExp } from 'services/actions/shopping-cart';
import { items } from 'services/selectors/shopping-cart';
import LoaderCP from 'components/loader';
import StepsLineComponent from 'components/steps-line';
import ShippingInformation from 'components/shopping-cart/shipping-information';
import AssistantsInformation from 'components/shopping-cart/assistants-information';
import PassengersInformation from 'components/shopping-cart/passengers-information';
import PassengersInformationInternational from 'components/shopping-cart/passengers-information-international';
import ModalConfirmation from 'components/modal-confirmation';
import { REDIRECT_LOGIN_LINK } from 'constants/Constants';
import ResumenTicket from './resumen-ticket';
import ResumenTicketMobile from './resumen-ticket-mobile';

const PaymentContainer = () => {
  const dispatch = useDispatch();
  const itemsCart = useSelector(items);
  const [personalData, setPersonalData] = useState({});
  const [personalAddress, setPersonalAddress] = useState({});
  const [isFetching, setIsFetching] = useState(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isfeching, setIsfeching] = useState(false);
  const history = useHistory();

  const { register, formState: { errors, isValid, isDirty }, handleSubmit, setFocus, clearErrors, setValue, trigger } = useForm({ mode: 'all' });
  const onSubmit = () => {
    const membersList = [];
    const experiences = document.querySelectorAll('.shopping-card-info');

    itemsCart.forEach((item, index) => {
      // Member List by experience
      const memberListByItem = [];
      // memberListByItem[0]
      const reservationHolder = {};
      // memberListByItem[0].address
      const address = {};
      // Reservation holder fields outside address
      const rhElementsWithNoAddress = experiences[index].querySelectorAll(
        `input[data-group="${index}"]:not([data-address]):not([data-companion]),
        select[data-group="${index}"]:not([data-address]:not([data-companion]),
        textarea[data-group="${index}"]:not([data-address]:not([data-companion])`,
      );
      // Reservation holder fields within address
      const rhAddressElements = experiences[index].querySelectorAll(
        `input[data-address="${index}"],
        select[data-address="${index}"],
        textarea[data-address="${index}"]`,
      );
      // Fill in the address object
      rhAddressElements.forEach((addressField) => {
        address[addressField.dataset.name] = addressField.value;
      });
      // Delete empty fields from the address object
      // eslint-disable-next-line no-restricted-syntax
      for (const key in address) {
        if (address[key] === '') {
          delete address[key];
        }
      }
      // Fill in the reservation holder object
      rhElementsWithNoAddress.forEach((field) => {
        reservationHolder[field.dataset.name] = field.value;
      });
      // Reservation holder final object
      const reservationHolderWithAddress = { ...reservationHolder, address };
      // Add reservation holder object into the memberListByItem array
      memberListByItem.push(reservationHolderWithAddress);

      // Number of companions by experience
      const numOfCompanions = experiences[index].querySelectorAll('.companion').length;
      for (let i = 0; i < numOfCompanions; i += 1) {
        // memberListByItem[n] Fields
        const companionsElements = experiences[index].querySelectorAll(`.companion input[data-companion="${i}"]`);
        // memberListByItem[n] object
        const companion = {};
        // Fill in the  memberListByItem[n] object
        companionsElements.forEach((companionField) => {
          companion[companionField.dataset.name.split('-')[0]] = companionField.value;
        });
        // Add companion object into the memberListByItem array
        memberListByItem.push(companion);
      }

      // Fill in the  memberList array
      membersList.push(memberListByItem);
    });

    // Dispatch the memberList by experience
    membersList.forEach((item, idx) => {
      dispatch(
        addPersonalDataToShoppingCartAction(Number(item[0].idexp), membersList[idx]),
      );
    });

    handleShow();
  };

  const submitShopping = async () => {
    setIsfeching(true);
    const data = {
      items: itemsCart,
    };

    const response = await dispatch(postShoppingCartAction(data));
    const {
      action: {
        payload: {
          status,
        },
      },
    } = response;

    if (status === 400 || status === 403 || status === 409 || status === 412 || status === 500) {
      setIsfeching(false);
      dispatch(getExclusivityBannerAction('NO_POINTS'));
      history.push('/experiencias-error');
      if (status === 403) {
        window.location.href = REDIRECT_LOGIN_LINK;
      }
    } else {
      setIsfeching(false);
      dispatch(resetExp());
      history.push('/experiencias-confirmacion');
    }
  };

  useEffect(async () => {
    const response = await dispatch(getSessionAction());
    const dataUserResponse = response.action.payload.data;
    const { status } = response.action.payload;

    if (status === 200) {
      setIsFetching(false);
      setPersonalData(dataUserResponse);
      setPersonalAddress(dataUserResponse.address);
    }
    if (status === 403) {
      setIsFetching(false);
      window.location.href = REDIRECT_LOGIN_LINK;
    }
    if (status === 400 || status === 409 || status === 412 || status === 500) {
      setIsFetching(false);
      history.push('/experiencias-error');
    } else {
      setIsFetching(false);
    }
  }, []);

  return (
    <>
      { isFetching ? <LoaderCP /> : (
        <>
          <ResumenTicketMobile resumen={itemsCart} />
          <Container fluid className="bg-white">
            {itemsCart && itemsCart.length > 0 ? (
              <ModalConfirmation
                stateInitial={show}
                handleClose={handleClose}
                itemsCart={itemsCart}
                isfeching={isfeching}
                submitShopping={submitShopping} />
            ) : '' }
            <Container>
              <Row className="justify-content-center">
                <Col lg={8}>
                  <StepsLineComponent itemActive={2} />
                </Col>
              </Row>
              <Row className="justify-content-center py-60">
                <Col lg={12} className="text-center">
                  <h1 className="text-tangaroa">Ingresa tus datos</h1>
                </Col>
                <form onSubmit={handleSubmit(onSubmit)} className="d-contents">
                  <Col lg={9} className="text-center">
                    {
                      /* eslint-disable */
                      itemsCart.map((item, index) => {
                        switch (item.type) {
                          case 'HOUSE': {
                            return (
                              <ShippingInformation
                                datas={item}
                                isGift={item.isGift}
                                key={index}
                                indexMap={index}
                                personalData={personalData}
                                addressData={personalAddress}
                                register={register}
                                errors={errors}
                                setFocus={setFocus}
                                setValue={setValue}
                                clearErrors={clearErrors} />
                            );
                          }
                          case 'MASTERCLASS': {
                            return (
                              <AssistantsInformation
                                datas={item}
                                isGift={item.isGift}
                                numberOfCompanion={Number(item.numberOfPeople) - 1}
                                key={index}
                                indexMap={index}
                                personalData={personalData}
                                addressData={personalAddress}
                                register={register}
                                errors={errors}
                                trigger={trigger}
                                setValue={setValue}
                                clearErrors={clearErrors} />
                            );
                          }
                          case 'IN_PERSON_SCHEDULED':
                          case 'FACE_TO_FACE': {
                            return (
                              <AssistantsInformation
                                datas={item}
                                isGift={item.isGift}
                                numberOfCompanion={Number(item.numberOfPeople) - 1}
                                key={index}
                                indexMap={index}
                                personalData={personalData}
                                addressData={personalAddress}
                                register={register}
                                errors={errors}
                                trigger={trigger}
                                setValue={setValue}
                                clearErrors={clearErrors} />
                            );
                          }
                          case 'TRAVEL': {
                            return (
                              <PassengersInformation
                                datas={item}
                                isGift={item.isGift}
                                numberOfCompanion={Number(item.numberOfPeople) - 1}
                                key={index}
                                indexMap={index}
                                personalData={personalData}
                                addressData={personalAddress}
                                register={register}
                                errors={errors}
                                trigger={trigger}
                                setFocus={setFocus}
                                setValue={setValue}
                                clearErrors={clearErrors} />
                            );
                          }
                          case 'TRAVEL_INTERNATIONAL': {
                            return (
                              <PassengersInformationInternational
                                datas={item}
                                isGift={item.isGift}
                                numberOfCompanion={Number(item.numberOfPeople) - 1}
                                key={index}
                                indexMap={index}
                                personalData={personalData}
                                addressData={personalAddress}
                                register={register}
                                errors={errors}
                                trigger={trigger}
                                setFocus={setFocus}
                                setValue={setValue}
                                clearErrors={clearErrors} />
                            );
                          }
                          default:
                            return '';
                        }
                      })
                    }
                    <Row className="py-15">
                      <Col lg={12} className="text-left">
                        <div className="custom-control custom-checkbox">
                          {/* eslint-disable react/jsx-props-no-spreading */}
                          <input
                            {...register('inputcheck', { required: true })}
                            id="custom-check-terms"
                            name="inputcheck"
                            className="custom-control-input"
                            onClick={async() => await trigger("inputcheck")}
                            type="checkbox" />
                          <label htmlFor="custom-check-terms" className="custom-control-label text-tangaroa">
                            He leído y acepto
                            <a href="https://www.aeromexicorewards.com/mx/terminos-y-condiciones-experiencias-premier/" className="ml-1 text-dark-blue link">Términos y Condiciones</a>
                          </label>
                        </div>
                        {errors.inputcheck && <small className="error-msg">* Campo requerido</small>}
                      </Col>
                    </Row>
                    <Row className="pb-60">
                      <Col lg={12} className="text-right">
                        <Link to="/mis-experiencias" className="btn btn-secondary my-15 mr-lg-15">Regresar</Link>
                        <button type="submit" className="btn btn-primary" disabled={!isValid || !isDirty}>Continuar</button>
                      </Col>
                    </Row>
                  </Col>
                </form>
                <Col lg={3}>
                  <ResumenTicket resumen={itemsCart} />
                </Col>
              </Row>
            </Container>
          </Container>
        </>
      ) }
    </>
  );
};

export default PaymentContainer;
